export function checkIdInArray(arr: any[], id: string) {
  if (arr) {
    return arr.indexOf(id) > -1;
  } else {
    return arr;
  }
}
